<template>
  <div class="animated fadeIn container-fluid">
    <h4 v-text="'近期操作 Recent Logs'"></h4>

    <div class="proj-toolbox-area">
      <b-row>
        <b-col md="6" xl="4" class="mb-2">
          <b-input-group size="lg">
            <b-input-group-prepend>
              <b-input-group-text>關鍵字搜尋</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input v-model="search.keyword"></b-form-input>
            <!-- <b-input-group-append>
                            <b-button variant="success" @click="getData_Records()">{{ $t('menu.search') }}</b-button>
                        </b-input-group-append> -->
          </b-input-group>
          <!-- <div class="instruction">
                        <i class="fa fa-info-circle"></i> 輸入中文的話只能搜尋一個字XD
                    </div> -->
        </b-col>

        <b-col md="6" xl="4" class="mb-2">
          <b-input-group size="lg">
            <b-input-group-prepend>
              <b-input-group-text>IP Address</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input v-model="search.ip_address"></b-form-input>
            <!-- <b-input-group-append>
                            <b-button variant="success" @click="getData_Records()">{{ $t('menu.search') }}</b-button>
                        </b-input-group-append> -->
          </b-input-group>
        </b-col>

        <b-col md="6" xl="4">
          <b-form-group class="mt-2 block-md">
            <b-form-checkbox-group v-model="search.types" buttons>
              <b-form-checkbox
                v-for="type in list_oplog_types"
                :key="type.value"
                :value="type.value"
                :button-variant="type.buttonVariant"
              >
                {{ type.value }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>

        <b-col md="6" xl="4">
          <div class="mt-2 block-md">
            <DatePickerTool
              :timezone="timezone"
              :no_bounding="true"
              :shortcut_no_shift="true"
              :default_query="default_date_range"
              @date-range="set_DateRange($event)"
            ></DatePickerTool>
          </div>
        </b-col>

        <b-col md="8" class="mb-2">
          <b-input-group size="lg">
            <b-input-group-prepend>
              <b-input-group-text
                >觀看特定使用者輸入使用者 ID</b-input-group-text
              >
            </b-input-group-prepend>
            <b-form-input
              type="text"
              class="form-control"
              v-model.trim="search.user_ids"
              :maxlength="100"
            />
          </b-input-group>
          <div class="text-muted">搜尋複數 ID 請以半形逗點隔開： ex. 1,2,3</div>
        </b-col>
      </b-row>

      <!-- 阿龜資料讀取畫面 -->
      <div v-if="loading">
        <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
      </div>
      <div v-else>
        <b-card>
          <b-row>
            <b-col md="5" xl="4">
              <b-input-group label-cols="5" class="mb-2">
                <b-input-group-prepend>
                  <b-input-group-text>每頁顯示數量</b-input-group-text>
                </b-input-group-prepend>
                <b-form-select
                  v-model="search.per_page"
                  :options="page_options"
                  style="max-width: 120px"
                ></b-form-select>
                <b-input-group-append>
                  <b-input-group-text
                    >{{ $t("menu.data_count") }}：{{
                      search.data_count
                    }}</b-input-group-text
                  >
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="7" xl="4">
              <b-input-group class="mb-2">
                <b-input-group-prepend>
                  <b-input-group-text>{{
                    $t("menu.order_by")
                  }}</b-input-group-text>
                </b-input-group-prepend>
                <b-select v-model="search.order_by" class="select-box">
                  <option
                    v-for="(option, idx_option) in list_sort"
                    :key="idx_option"
                    :value="option.value"
                    class="select-item"
                  >
                    {{ option.text }}
                  </option>
                </b-select>
              </b-input-group>
            </b-col>
            <b-col>
              <!-- 分頁 -->
              <div v-if="search" class="justify-content-center">
                <b-pagination
                  v-model="search.current_page"
                  :total-rows="search.data_count"
                  :per-page="search.per_page"
                  aria-controls="records-list"
                  pills
                  align="center"
                ></b-pagination>
              </div>
            </b-col>
          </b-row>

          <div class="edit-area" v-if="list_result && list_result.length > 0">
            <b-row align-h="center">
              <b-col md="8" class="text-center" v-if="log_range">
                <div v-if="log_range" v-html="log_range"></div>
              </b-col>
              <!-- <b-col md="4">
                                <b-form-group label-cols-md="4" :label="$t('menu.per_page')" class="mb-0">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col> -->
            </b-row>

            <div class="list-table-result scroll-style-gray overflow-x">
              <b-table
                hover
                small
                responsive="xl"
                :fields="table_fields"
                :items="table_items"
              >
                <!-- A virtual column -->
                <template #cell(see_user)="row">
                  <b-button
                    size="sm"
                    class="btn-warning"
                    :to="{
                      name: 'Edit User',
                      params: { userID: row.item.user_id },
                    }"
                  >
                    <!-- <i class="fa fa-gear block-text"></i> -->
                    See User
                  </b-button>
                </template>

                <template #cell(page)="row">
                  <div v-if="row.item.detail">{{ row.item.detail.page }}</div>
                </template>

                <template #cell(action)="row">
                  <div v-if="row.item.detail">{{ row.item.detail.action }}</div>
                </template>

                <template #cell(details)="row">
                  <b-button
                    size="sm"
                    @click="row.toggleDetails"
                    class="mr-2 btn-warning"
                  >
                    {{ row.detailsShowing ? "Hide" : "Show" }}
                  </b-button>
                </template>
                <template #row-details="row">
                  <div
                    v-for="(detail_item, detail_key, idx_di) in row.item.detail"
                    :key="idx_di"
                  >
                    <div v-if="typeof detail_item == 'array'">
                      <div class="detail-key">
                        <i class="fa fa-paw block-title"></i>{{ detail_key }}：
                      </div>
                      <div class="detail-item">{{ detail_item }}</div>
                    </div>
                    <div v-else-if="typeof detail_item == 'object'">
                      <div class="detail-key">
                        <i class="fa fa-paw block-title"></i>{{ detail_key }}：
                      </div>
                      <div class="proj-toolbox-area detail-item">
                        <div
                          v-for="(dd_item, dd_key, idx_ddi) in detail_item"
                          :key="idx_ddi"
                        >
                          <div class="detail-title">- {{ dd_key }}：</div>
                          <div class="detail-item">{{ dd_item }}</div>

                          <!-- 加上超連結 -->
                          <router-link
                            v-if="dd_key == 'project ID'"
                            class="detail-buttom"
                            :to="{
                              name: 'Project Summary',
                              params: { projectID: dd_item },
                            }"
                          >
                            <i class="fa fa-external-link-square clickable"></i>
                          </router-link>
                          <router-link
                            v-if="
                              dd_key == 'cropperiod ID' &&
                              detail_item['project ID'] != undefined
                            "
                            class="detail-buttom"
                            :to="{
                              name: 'Cropperiod',
                              params: {
                                projectID: detail_item['project ID'],
                                cropperiodID: dd_item,
                              },
                            }"
                          >
                            <i class="fa fa-external-link-square clickable"></i>
                          </router-link>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="detail-key">
                        <i class="fa fa-paw block-title"></i>{{ detail_key }}：
                      </div>
                      <div class="detail-item">{{ detail_item }}</div>
                    </div>
                  </div>

                  <br />
                </template>
              </b-table>

              <!-- 分頁 -->
              <div v-if="search" class="justify-content-center">
                <b-pagination
                  v-model="search.current_page"
                  :total-rows="search.data_count"
                  :per-page="search.per_page"
                  aria-controls="records-list"
                  pills
                  align="center"
                ></b-pagination>
              </div>
              <div class="text-center">
                {{ $t("menu.data_count") }}：{{ search.data_count }}
              </div>
            </div>
          </div>
          <div v-else>
            <NoData></NoData>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NoData from "@/views/components/NoData";
import AgriLoading from "@/views/components/AgriLoading";
import DatePickerTool from "@/views/components/DatePickerTool";

export default {
  components: {
    NoData,
    AgriLoading,
    DatePickerTool,
  },
  data() {
    return {
      loading: false,
      timezone: "Asia/Taipei",
      default_date_range: [undefined, undefined],
      list_result: [],

      // 搜尋條件
      query_string: "",
      search: {
        keyword: "",
        data_count: 0,
        per_page: 20,
        current_page: 1,
        order_by: "-log_time",
        types: [],
        user_ids: "",
        ip_address: "",
        start_time: undefined,
        end_time: undefined,
      },
      list_sort: [
        { value: "-id", text: "id 降序" },
        { value: "id", text: "id" },

        { value: "-log_time", text: "log_time 降序" },
        { value: "log_time", text: "log_time" },
      ],
      page_options: [
        { value: 10, text: 10 },
        { value: 20, text: 20 },
        { vlaue: 50, text: 50 },
        { value: 100, text: 100 },
      ],

      // table
      table_items: [],
    };
  },
  mounted() {
    this.timezone = this.$tools.date.getTimezoneNow();
    this.get_QueryString();
    this.getData_Records();
  },
  computed: {
    ...mapState({
      list_oplog_types: (state) => state.admin.list_oplog_types,
    }),

    table_fields() {
      return [
        { key: "see_user", sortable: false, label: undefined },
        { key: "id", sortable: true, label: "Log" },
        { key: "user_id", sortable: true, label: "User" },
        { key: "type", sortable: true, label: this.$t("menu.type") },
        { key: "log_time", sortable: true, label: "操作時間" },
        { key: "page", sortable: true, label: "操作頁面" },
        { key: "action", sortable: true, label: "Action" },
        { key: "ip_address", sortable: true, label: "IP Address" },
        { key: "details", sortable: false, label: this.$t("menu.detail") },
      ];
    },
  },
  watch: {
    "search.keyword"() {
      this.get_QueryString();
    },
    "search.per_page"() {
      this.get_QueryString();
    },
    "search.current_page"() {
      this.get_QueryString();
    },
    "search.order_by"() {
      this.get_QueryString();
    },
    "search.types"() {
      this.get_QueryString();
    },
    "search.ip_address"() {
      this.get_QueryString();
    },
    "search.start_time"() {
      this.get_QueryString();
    },
    "search.end_time"() {
      this.get_QueryString();
    },
    "search.user_ids"(val) {
      let _split_ids = val.split(",");
      let _list_ids = [];

      _split_ids.forEach((_id) => {
        let _int_id = parseInt(_id);
        if (_int_id && _list_ids.indexOf(_int_id) == -1)
          _list_ids.push(_int_id);
      });
      this.search.user_ids = _list_ids.join(",");
      this.get_QueryString();
    },

    query_string() {
      // if ( this.query_string == '' )  window.history.replaceState( '', '', location.pathname ) // 無 query
      // else                            window.history.replaceState( '', '', this.query_string )

      this.getData_Records();
    },
  },
  methods: {
    set_DateRange(date_range) {
      if (
        date_range != undefined &&
        date_range.start_time != undefined &&
        date_range.end_time != undefined
      ) {
        this.search.start_time = this.$tools.date.dataTimeZone_to_UTC(
          date_range.start_time,
          this.timezone
        );
        this.search.end_time = this.$tools.date.dataTimeZone_to_UTC(
          date_range.end_time,
          this.timezone
        );
      } else {
        this.search.start_time = undefined;
        this.search.end_time = undefined;
      }
    },

    // 使用正規表達式判斷是否字串為純中文
    is_PureChinese(input) {
      var reg = /^[\u4E00-\u9FA5]+$/;
      if (reg.test(input)) {
        return true;
      } else {
        return false;
      }
    },

    // 將 utf-8 轉為 unicode (資料庫搜尋 json string 使用 unicode)
    UTF8_to_UniCode(utf8_string) {
      let _chars = [];
      if (utf8_string != undefined && utf8_string != "") {
        for (let i = 0; i < utf8_string.length; i++) {
          if (this.is_PureChinese(utf8_string[i]) == true) {
            // EX: utf8_string = "中文";
            // 獲取字元
            let char0 = utf8_string.charAt(i); // "中"
            // 數字編碼值
            let code = utf8_string.charCodeAt(i); // 20013
            // 編碼互轉
            // let str0 = String.fromCharCode(code); // "中"
            // 轉為16進位制陣列
            let code16 = code.toString(16); // "4e2d"
            // 變成字面量表示法
            let ustr = "\\u" + code16; // "\u4e2d"
            _chars.push("\\" + ustr);
          } else _chars.push(utf8_string[i]);
        }
      }
      return _chars.join("");
    },

    get_QueryString() {
      let _query_string = "";
      let _query_stack = [];

      if (this.search.keyword != "") {
        _query_stack.push("q=" + this.UTF8_to_UniCode(this.search.keyword));
      }

      if (this.search.per_page != null) {
        _query_stack.push("limit=" + this.search.per_page);
      }

      if (this.search.current_page != null) {
        let _skip = (this.search.current_page - 1) * this.search.per_page;
        _query_stack.push("skip=" + _skip);
      }

      if (this.search.order_by != null) {
        _query_stack.push("order_by=" + this.search.order_by);
      }

      if (this.search.types.length > 0) {
        _query_stack.push("types=" + this.search.types.join(","));
      }

      if (this.search.user_ids != "") {
        _query_stack.push("user_ids=" + this.search.user_ids);
      }
      if (this.search.ip_address != "") {
        _query_stack.push("ip=" + this.search.ip_address);
      }

      if (
        this.search.start_time != undefined &&
        this.search.end_time != undefined
      ) {
        _query_stack.push("start_time=" + this.search.start_time);
        _query_stack.push("end_time=" + this.search.end_time);
      }

      if (_query_stack.length > 0) _query_string = "?" + _query_stack.join("&");

      this.query_string = _query_string;
    },

    getData_Records() {
      this.loading = true;
      const options = {
        method: "GET",
        url: this.$config.getAPI_URL("Get_OPLogs") + this.query_string,
      };
      this.$http(options)
        .then((res) => {
          this.loading = false;

          this.search.data_count = res.data.count;

          let _all_logs = res.data.user_operation_logs;
          if (_all_logs && _all_logs.length > 0) {
            _all_logs.forEach((_log) => {
              // 時區轉換
              _log.log_time = this.$tools.date.dateTimeZone(
                _log.log_time,
                this.timezone,
                "YYYY-MM-DD HH:mm:ss"
              );
            });

            if (_all_logs.length > 0) {
              this.log_range = `<span class="err-msg block-text">【 Logs ID：  ${
                _all_logs[0].id
              } ~ ${_all_logs[_all_logs.length - 1].id} 】</span>`;
              this.log_range += ` ${_all_logs[0].log_time} ~ ${
                _all_logs[_all_logs.length - 1].log_time
              }`;
            } else this.log_range = undefined;

            /*
                        [{
                            "id":758,
                            "user_id":2,
                            "log_time":"2019-08-27 10:01:12",
                            "type":"write",
                            "ip_address":"36.231.22.99",
                            "detail":{
                                "page":"cropperiod",
                                "action":"reset status",
                                "querySettings":{
                                    "project ID":"3",
                                    "project name":"阿龜辦公室",
                                    "cropperiod ID":8,
                                    "cropperiod name":"一個期作",
                                    "cropperiod status":"done => farming",
                                    "project status":"activate",
                                    "service level":"education"
                                }
                            }
                        }]
                         */
          }
          this.list_result = _all_logs;
          this.arrangeTableData();
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    arrangeTableData() {
      let _items = [];
      this.list_result.forEach((_data, _idx) => {
        let _new_data = this.$tools.data.deepCopy_object(_data); // 複製一份

        _new_data["idx"] = _idx + 1;

        _items.push(_new_data);
      });
      this.table_items = _items;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-area {
  padding: 10px 15px;
}

.detail-key {
  display: inline-block;
  margin-left: 10px;
  color: #257d57;
}
.detail-title {
  display: inline-block;
  margin-left: 10px;
  color: #0086b3;
}
.detail-item {
  display: inline-block;
  margin-left: 10px;
}
.detail-buttom {
  padding: 5px 10px;
  font-size: 1.4rem;
}
</style>
